import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { PageTitle } from '@/components/page-title'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useSession } from '@/contexts/auth/session'
import useTranslator from '@/hooks/translation'
import { LoginForm } from '@/pages/auth/login/components/form'

export function LoginPage() {
  const { getTranslation } = useTranslator()
  const {
    state: { isUserAuthenticated },
  } = useSession()

  const navigate = useNavigate()

  useEffect(() => {
    if (isUserAuthenticated) {
      navigate('/companies')
    }
  }, [navigate, isUserAuthenticated])

  return (
    <>
      <PageTitle title={getTranslation('auth.login.metadata')} />

      <Card className="flex min-h-screen w-full min-w-[280px] flex-col bg-card-opaque md:h-fit md:min-h-0 md:w-[560px] md:justify-between md:pt-6">
        <CardHeader className="w-full space-y-6">
          <img
            src="/images/logos/fintalk.svg"
            alt="Fintalk logo"
            width={140}
            className="mx-auto object-cover"
          />

          <CardTitle className="mx-auto text-center">
            {getTranslation('auth.login.title')}
          </CardTitle>
        </CardHeader>

        <CardContent className="w-full p-6 md:px-0 md:pb-0">
          <LoginForm />
        </CardContent>
      </Card>
    </>
  )
}
